import { api } from './axios';
import type {
  StartListGroup,
  CreateStartListGroupRequest,
  StartList,
  ReorderStartListEntryRequest,
} from '../types/startList';

export const startListApi = {
  findByDiscipline: (disciplineId: number) =>
    api
      .get<StartListGroup[]>(`/admin/disciplines/${disciplineId}/start-list-groups`)
      .then((r) => r.data),

  findById: (id: number) =>
    api.get<StartListGroup>(`/admin/start-list-groups/${id}`).then((r) => r.data),

  create: (disciplineId: number, req: CreateStartListGroupRequest) =>
    api
      .post<StartListGroup>(`/admin/disciplines/${disciplineId}/start-list-groups`, req)
      .then((r) => r.data),

  update: (id: number, req: CreateStartListGroupRequest) =>
    api.put<StartListGroup>(`/admin/start-list-groups/${id}`, req).then((r) => r.data),

  remove: (id: number) =>
    api.delete<void>(`/admin/start-list-groups/${id}`).then(() => undefined),

  resetFromTemplate: (disciplineId: number) =>
    api
      .post<StartListGroup[]>(
        `/admin/disciplines/${disciplineId}/start-list-groups/reset-from-template`,
      )
      .then((r) => r.data),

  // Phase 3 — generator startovky
  generate: (groupId: number) =>
    api.post<StartList>(`/admin/start-list-groups/${groupId}/generate`).then((r) => r.data),

  getStartList: (groupId: number) =>
    api.get<StartList>(`/admin/start-list-groups/${groupId}/start-list`).then((r) => r.data),

  reorderEntry: (entryId: number, req: ReorderStartListEntryRequest) =>
    api
      .patch<{ id: number; heatNumber: number; laneNumber: number }>(
        `/admin/start-list-entries/${entryId}`,
        req,
      )
      .then((r) => r.data),

  publicGetStartList: (groupId: number) =>
    api.get<StartList>(`/public/start-list-groups/${groupId}/start-list`).then((r) => r.data),

  publicFindByDiscipline: (disciplineId: number) =>
    api
      .get<StartListGroup[]>(`/public/disciplines/${disciplineId}/start-list-groups`)
      .then((r) => r.data),
};
